"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  assertEnvVar: () => assertEnvVar,
  assertPublishableKeyInSpaMode: () => assertPublishableKeyInSpaMode,
  assertValidClerkState: () => assertValidClerkState,
  getEnvVariable: () => getEnvVariable,
  inSpaMode: () => inSpaMode,
  warnForSsr: () => warnForSsr
});
module.exports = __toCommonJS(utils_exports);
var import_errors = require("./errors");
function warnForSsr(val) {
  if (!val || !val.__internal_clerk_state) {
    console.warn(import_errors.noClerkStateError);
  }
}
function assertEnvVar(name, errorMessage) {
  if (!name || typeof name !== "string") {
    throw new Error(errorMessage);
  }
}
function assertValidClerkState(val) {
  if (!val) {
    throw new Error(import_errors.noClerkStateError);
  }
  if (!!val && !val.__internal_clerk_state) {
    throw new Error(import_errors.invalidClerkStatePropError);
  }
}
function assertPublishableKeyInSpaMode(key) {
  if (!key || typeof key !== "string") {
    throw new Error(import_errors.publishableKeyMissingErrorInSpaMode);
  }
}
const hasCloudflareProxyContext = (context) => {
  var _a;
  return !!((_a = context == null ? void 0 : context.cloudflare) == null ? void 0 : _a.env);
};
const hasCloudflareContext = (context) => {
  return !!(context == null ? void 0 : context.env);
};
const getEnvVariable = (name, context) => {
  if (typeof process !== "undefined" && process.env && typeof process.env[name] === "string") {
    return process.env[name];
  }
  if (hasCloudflareProxyContext(context)) {
    return context.cloudflare.env[name] || "";
  }
  if (hasCloudflareContext(context)) {
    return context.env[name] || "";
  }
  if (context && typeof context[name] === "string") {
    return context[name];
  }
  try {
    return globalThis[name];
  } catch {
  }
  return "";
};
const inSpaMode = () => {
  var _a;
  if (typeof window !== "undefined" && typeof ((_a = window.__remixContext) == null ? void 0 : _a.isSpaMode) !== "undefined") {
    return window.__remixContext.isSpaMode;
  }
  return false;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  assertEnvVar,
  assertPublishableKeyInSpaMode,
  assertValidClerkState,
  getEnvVariable,
  inSpaMode,
  warnForSsr
});
//# sourceMappingURL=utils.js.map